//
import type { AxiosItem } from '@/types/Components/Response'
import type { CommonStoreState } from '@/types/Store'
import { defineStore } from 'pinia'
import ApiProxy from '@/proxies/ApiProxy'

export const useCommonStore = defineStore('common', {
  state: (): CommonStoreState => ({
    downloadUrl: null,
    loading: false,
  }),
  actions: {
    checkDownloadFile(file: string) {
      this.loading = true

      return new ApiProxy()
        .getReportFile(file)
        .then((response: AxiosItem) => {
          this.downloadUrl = response.data.downloadUrl
          return response
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
})

export type CommonStore = ReturnType<typeof useCommonStore>
